import {
  Component,
  ConfigurationActionTypes,
  PowerMeter,
  ShopSystemConfiguration,
  SystemConfigurationActionTypes,
} from './ShopSystemConfigurationModel'

export const addComponent = (component: Component): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.AddComponent,
  payload: component,
})

export const removeComponent = (componentId: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.RemoveComponent,
  payload: componentId,
})

export const addProduct = (componentId: string, productId: string, qty: number): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.AddProduct,
  payload: {
    componentId,
    productId,
    qty,
  },
})

export const addRetrofitBattery = (id: string, qty: number): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.AddRetrofitBattery,
  payload: {
    id,
    qty,
  },
})

export const removeRetrofitBattery = (productId: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.RemoveRetrofitBattery,
  payload: productId,
})

export const removeProduct = (componentId: string, productId: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.RemoveProduct,
  payload: { componentId, productId },
})

export const addPowerMeter = (powerMeter: PowerMeter): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.AddPowerMeter,
  payload: powerMeter,
})

export const removePowerMeter = (powerMeterId: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.RemovePowerMeter,
  payload: powerMeterId,
})

export const setQuantity = (quantity: number): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.SetQuantity,
  payload: quantity,
})

export const updateLabel = (label: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.UpdateLabel,
  payload: label,
})

export const setShippingDate = (day: number, month: number, year: number): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.SetShippingDate,
  payload: { day, month, year },
})

export const updateConfiguratorId = (configuratorId: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.SetConfiguratorId,
  payload: configuratorId,
})

export const increaseQuantity = (componentId: string, productId: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.IncreaseQuantity,
  payload: {
    componentId,
    productId,
  },
})

export const decreaseQuantity = (componentId: string, productId: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.DecreaseQuantity,
  payload: {
    componentId,
    productId,
  },
})

export const addConfigurator = (component: ShopSystemConfiguration): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.AddConfigurator,
  payload: component,
})

export const resetConfigurator = (): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.ResetConfigurator,
})

export const addSmartMeter = (id: string): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.AddSmartMeter,
  payload: {
    id,
  },
})

export const removeSmartMeter = (): ConfigurationActionTypes => ({
  type: SystemConfigurationActionTypes.RemoveSmartMeter,
})
